import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { updateImage } from '@/data/api/request/productCatalogRequests';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpdateImage() {
  const queryClient = useQueryClient();
  const { showSnackError } = useSnackbarContext();

  const updateImageHook = useMutation({
    mutationFn: (args: { productId: string; skuId: string; file: File }) =>
      updateImage(args),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [cacheKeys.product.catalog] }),
    onError: () => showSnackError('Error al actualizar imagen'),
  });

  return {
    updateImage: updateImageHook.mutate,
  };
}
